import React from 'react'
import PropTypes from 'prop-types'

import { StyledLink, StyledIcon, Text } from './IconLinkStyle'

const IconLink = ({
  color,
  size,
  icon,
  right,
  responsive,
  children,
  ...props
}) => {
  const iconElement = (
    <StyledIcon
      size={size && size / 3}
      icon={icon}
      hasText={!!children}
      right={right}
      responsive={responsive}
      color={color}
    />
  )

  return (
    <StyledLink {...props}>
      {!right && iconElement}
      <Text responsive={responsive}>{children}</Text>
      {right && iconElement}
    </StyledLink>
  )
}

IconLink.propTypes = {
  icon: PropTypes.string.isRequired,
  responsive: PropTypes.bool,
  right: PropTypes.bool,
  size: PropTypes.number,
  color: PropTypes.string,
  children: PropTypes.any,
  onClick: PropTypes.func,
}

export default IconLink
